"use client";

import { DialogContent, DialogTitle } from "@mui/material";
import { useDeleteDialog } from "../Providers/DeleteDialogContext";

export default function DeleteDialogContent() {
  const { campaignIdsToDelete } = useDeleteDialog();
  const campaignCount = campaignIdsToDelete.length;

  return (
    <>
      <DialogTitle>{`Delete Campaign${campaignCount > 1 ? "s" : ""}`}</DialogTitle>
      <DialogContent>
        {`Are you sure you want to delete ${campaignCount} campaign${campaignCount === 1 ? "" : "s"}? This action cannot be undone.`}
      </DialogContent>
    </>
  );
}
